import { createClasses } from "@bloomberg/media-ui-core";
import React, { forwardRef } from "react";
import { PropsWithClassAndChildren } from "../types";

import styles from "./GridLayout.module.css";

export const GridLayout = forwardRef<HTMLDivElement, PropsWithClassAndChildren>(
  function GridLayout({ children, className, id, ...args }, ref) {
    const cx = createClasses([styles.gridLayout, className]);

    return (
      <div className={cx} ref={ref} data-story-id={id} {...args}>
        {children}
      </div>
    );
  }
);
